module.exports = __webpack_public_path__ + "img/alerttruck-btn.fc6280b2.png";